export default __webpack_public_path__ + "static/media/CB.5e4a5b1f.png";